import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { Box } from '@mui/material';
import { common } from '@mui/material/colors';

const BackButton = () => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1); // Navigate to the previous page
    };

    return (
        <Box id="toggle-btn">
            <button onClick={handleBackClick} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                <ArrowBackIosNewOutlinedIcon sx={{ color: common.white }} />
            </button>
        </Box>
    );
};

export default BackButton;